import {useState} from 'react';

import ageGateService from '@/services/ageGate/ageGateService';

import {AgeGateForm} from './components/AgeGateForm';
import {AgeGateLocked} from './components/AgeGateLocked';

const AgeGatePage = () => {
    const [isLocked, setIsLocked] = useState(() => ageGateService.isAgeGateLocked());

    if (isLocked) {
        return <AgeGateLocked onUnlocked={() => setIsLocked(false)} />;
    }

    return <AgeGateForm onLocked={() => setIsLocked(true)} />;
};

export default AgeGatePage;
